import DayPartsFactory from "../../../models/day-parts-factory";
import { DateTime } from "luxon";
import { DEFAULT_TIMEZONE } from "@/utils";
import DayPart from "../../../models/day-part";

export const getDefaultState = () => {
  return {
    dayParts: null
  };
};

// initial state
const state = getDefaultState();

// getters
const getters = {
  getActiveDayParts: (state) => {
    return state.dayParts || [];
  },
  /**
   * Find Day Parts for given time
   *
   * @param {String | null} selectedTime in ISO8601 (defaults to "now")
   *
   * @return {DayPart[]} collection of DayPart
   */
  getDayPartsBySelectedTime:
    (state, getters, rootState, rootGetters) =>
    (selectedTime = undefined) => {
      const { dayParts = [], timezone = DEFAULT_TIMEZONE } = rootGetters["venue/getVenueInfo"];
      const activeDayParts = [];
      const atTime = selectedTime
        ? DateTime.fromISO(selectedTime).setZone(timezone).toFormat("yyyy-MM-dd HH:mm")
        : DateTime.now().setZone(timezone).toFormat("yyyy-MM-dd HH:mm");
      dayParts.forEach((dayPart) => {
        const dayPartExtended = {
          ...dayPart,
          atTime
        };

        const dayPartObj = DayPartsFactory.createDayPart(dayPartExtended, timezone);
        if (dayPartObj.isActive()) {
          activeDayParts.push(dayPart);
        }
      });
      return activeDayParts;
    }
};

// actions
const actions = {
  setVenueDayParts({ commit, getters, rootGetters }) {
    const selectedPickup = rootGetters["orderAhead/selectedPickup"];
    const activeDayParts = getters.getDayPartsBySelectedTime(selectedPickup);

    return commit("setVenueDayParts", activeDayParts);
  }
};

// mutations
const mutations = {
  setVenueDayParts(state, data) {
    state.dayParts = data;
  },
  resetState(state) {
    Object.assign(state, getDefaultState());
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
